import React from 'react';
import { Instagram, Facebook, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black py-12 px-4 sm:px-6 lg:px-8 border-t border-slate-900" data-id="element-15">
      <div className="max-w-7xl mx-auto" data-id="element-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-17">
          {/* Brand */}
          <div data-id="element-18">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-19">Kumo Izakaya</h3>
            <p className="text-gray-300" data-id="element-20">
              Modern Japanese dining experience in the heart of the city.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-21">
            <h4 className="text-lg font-semibold text-white mb-4" data-id="element-22">
              Quick Links
            </h4>
            <ul className="space-y-2" data-id="element-23">
              <li data-id="element-24">
                <a href="#menu" className="text-gray-300 hover:text-amber-400 transition-colors" data-id="element-25">
                  Menu
                </a>
              </li>
              <li data-id="element-26">
                <a href="#reservations" className="text-gray-300 hover:text-amber-400 transition-colors" data-id="element-27">
                  Reservations
                </a>
              </li>
              <li data-id="element-28">
                <a href="#events" className="text-gray-300 hover:text-amber-400 transition-colors" data-id="element-29">
                  Private Events
                </a>
              </li>
              <li data-id="element-30">
                <a href="#contact" className="text-gray-300 hover:text-amber-400 transition-colors" data-id="element-31">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div data-id="element-32">
            <h4 className="text-lg font-semibold text-white mb-4" data-id="element-33">Follow Us</h4>
            <div className="flex gap-4" data-id="element-34">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="bg-slate-900 hover:bg-amber-500 p-3 rounded-full transition-all duration-300 border border-slate-800 hover:border-amber-500" aria-label="Follow us on Instagram" data-id="element-35">
                <Instagram className="w-5 h-5 text-white" data-id="element-36" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="bg-slate-900 hover:bg-amber-500 p-3 rounded-full transition-all duration-300 border border-slate-800 hover:border-amber-500" aria-label="Follow us on Facebook" data-id="element-37">
                <Facebook className="w-5 h-5 text-white" data-id="element-38" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="bg-slate-900 hover:bg-amber-500 p-3 rounded-full transition-all duration-300 border border-slate-800 hover:border-amber-500" aria-label="Follow us on Twitter" data-id="element-39">
                <Twitter className="w-5 h-5 text-white" data-id="element-40" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-900 pt-8 text-center" data-id="element-41">
          <p className="text-gray-500" data-id="element-42">
            © {new Date().getFullYear()} Kumo Izakaya. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}